import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // useNavigate 임포트
import { useAuth } from "../../context/AuthContext";

import { MdContentCopy, MdMedicalServices } from "react-icons/md";
import "../../styles/InfoCard.css";

const InfoCard = ({
  Server_IP,
  token,
  userType,
  clientCode,
  getClientInfo,
  resetTrigger,
}) => {
  const [clientInfo, setClientInfo] = useState({
    clientName: "",
    clientcode: "",
    ceoName: "",
    phone: "",
    email: "",
    address: "",
    notes: "",
    MajorTransaction: "",
  });

  useEffect(() => {
    getClientInfo(Server_IP, token, clientCode, setClientInfo);
  }, [Server_IP, token, clientCode]);

  useEffect(() => {
    if (resetTrigger) {
      setClientInfo({
        clientName: "",
        clientcode: "",
        ceoName: "",
        phone: "",
        email: "",
        address: "",
        notes: "",
        MajorTransaction: "",
      });
    }
  }, [resetTrigger]);

  const navigate = useNavigate(); // useNavigate 훅 사용

  const handlePasswordChangeClick = () => {
    navigate("/passwordChange", {
      state: {
        Server_IP,
        token,
        clientCode,
      },
    });
  };

  const handleAddressCopy = async () => {
    const deliveryAddress = clientInfo.DeliveryAddr || "";

    try {
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(deliveryAddress);
          return;
        } catch (error) {
          // 운영 서버가 비보안 컨텍스트인 경우 legacy fallback을 시도합니다.
          console.warn("Clipboard API 복사 실패, fallback을 시도합니다.", error);
        }
      }

      const textArea = document.createElement("textarea");
      textArea.value = deliveryAddress;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      let copied;
      try {
        textArea.focus();
        textArea.select();
        copied = document.execCommand("copy");
      } finally {
        document.body.removeChild(textArea);
      }

      if (!copied) {
        throw new Error("복사 명령이 거부되었습니다.");
      }
    } catch (error) {
      console.error("배송지 복사 실패:", error);
      alert("배송지를 복사하지 못했습니다. 다시 시도해 주세요.");
    }
  };

  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber || typeof phoneNumber !== "string") return "";

    const value = phoneNumber.replace(/\D/g, "");
    const len = value.length;

    // 02로 시작하는 서울 지역번호 (2자리)
    if (value.startsWith("02")) {
      if (len === 9) {
        return `${value.slice(0, 2)}-${value.slice(2, 5)}-${value.slice(5)}`;
      } else if (len === 10) {
        return `${value.slice(0, 2)}-${value.slice(2, 6)}-${value.slice(6)}`;
      }
    }

    // 기타 지역번호 또는 휴대폰 (3자리로 시작)
    if (len === 10) {
      return `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
    } else if (len === 11) {
      return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7)}`;
    }

    // 8자리 공통번호 (예: 1588-1234)
    if (len === 8) {
      return `${value.slice(0, 4)}-${value.slice(4)}`;
    }

    // 그 외 (길이가 7자리 이하 등)
    if (len > 3) {
      const prefix = value.startsWith("02") ? 2 : 3;
      if (len > prefix) {
        return `${value.slice(0, prefix)}-${value.slice(prefix)}`;
      }
    }

    return value;
  }
  const formatNumber = (value) => {
    if (!value) return "";
    const number = parseInt(value.toString().replace(/,/g, ""), 10);
    return isNaN(number) ? "" : number.toLocaleString();
  };

  return (
    <div
      className={`info-card modern ${
        userType === "client" ? "client-expanded" : ""
      }`}
    >
      <div className="term-header modern">
        <div className="term-icon">
          <MdMedicalServices size={30} />
        </div>
        <div className="term-text">거래처 정보</div>
      </div>

      <div className="client-info">
        <div className="info-row">
          <div className="label-container justify ">
            <span className="label">거래처명</span>
          </div>
          <span className="badge badge-bg-secondary badge-lg">
            {clientInfo.ClientName}
          </span>
        </div>
        <div className="info-row">
          <div className="label-container justify">
            <span className="label">거래처코드</span>
          </div>
          <span>{clientInfo.ClientCode}</span>
        </div>
        <div className="info-row">
          <div className="label-container justify">
            <span className="label">대표자</span>
          </div>
          <span>{clientInfo.DeputyName}</span>
        </div>
        <div className="info-row">
          <div className="label-container justify">
            <span className="label">전화번호</span>
          </div>
          <span>{formatPhoneNumber(clientInfo.Tel)}</span>
        </div>
        <div className="info-row">
          <div className="label-container justify">
            <span className="label">이메일</span>
          </div>
          <span>{clientInfo.Email}</span>
        </div>
        <div className="info-row">
          <div className="label-container justify">
            <span className="label">배송지</span>
          </div>
          <div className="delivery-address">
            <span>{clientInfo.DeliveryAddr}</span>
            {userType === "manager" && (
              <button
                type="button"
                className="copy-address-btn"
                onClick={handleAddressCopy}
                aria-label="배송지 복사"
                title="배송지 복사"
              >
                <MdContentCopy aria-hidden="true" />
              </button>
            )}
          </div>
        </div>
        {/* 
        추후 사용을 대비해 숨김 처리한 임시 블록
        <div className="info-row">
          <div className="label-container justify">
            <span className="label">미수금액</span>
          </div>
          {clientInfo.UAMT_M && clientInfo.UAMT_M !== "0" && (
            <span>M({formatNumber(clientInfo.UAMT_M)})</span>
          )}
          {clientInfo.UAMT_T && clientInfo.UAMT_T !== "0" && (
            <span>T({formatNumber(clientInfo.UAMT_T)})</span>
          )}
        </div>
        */}
        <div className="info-row note-row">
          <div className="label-container justify">
            <span className="label">특이사항</span>
          </div>
          <span>{clientInfo.notes}</span>
        </div>
      </div>

      {/* 라디오 그룹 + 비밀번호 변경 버튼을 한 줄에 정렬 */}
      <div className="bottom-bar">
        {userType !== "manager" && (
          <button className="badge-btn" onClick={handlePasswordChangeClick}>
            비밀번호 변경
          </button>
        )}
      </div>
    </div>
  );
};

export default InfoCard;
